import React from "react";
import { Accordion, Col, Row, Card } from "react-bootstrap";
import SubjectsView from "../components/SubjectsView";
import { withData } from "../common/WithData";
import StudentController from "../api/StudentController";
import Loader from "react-loader";

interface HistoricClassesAccordionViewProps
{
    data: Class;
}

interface HistoricClassesAccordionViewState
{
    isloading: boolean;
    subjectData: Class;
    open: boolean;
}

export default class HistoricClassesAccordionView extends React.Component<HistoricClassesAccordionViewProps, HistoricClassesAccordionViewState>
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);

        this.studentController = new StudentController();
        this.state = {
            isloading: true,
            subjectData: null,
            open: false
        };
    }

    async getClassData(termCode: string)
    {
        const data = await this.studentController.getClasses(termCode);

        this.setState({
            isloading: false,
            subjectData: data.classes[0],
            open: !this.state.open
        });
    }

    render(): React.ReactNode 
    {
        return <Accordion>
            <Card>
                <Accordion.Toggle aria-expanded={this.state.open} href={"javascript:void(0)"} as={"a"} variant="link" eventKey="0" onClick={() => this.getClassData(this.props.data.termCode)}>
                    <Card.Header>
                        <Row>
                            <Col xs={6}>
                                <span style={{ color: "#0E4180" }}><b>{this.props.data.termCode}</b></span>
                            </Col>
                            <Col xs={4} className="text-right">
                                <b>GPA <span className="badge badge-light">{this.props.data.gpa ? this.props.data.gpa : "-"}</span></b>
                            </Col>
                            <Col xs={1} className="text-right chevron">
                                <i className={this.state.open ? " far fa-chevron-up" : "far fa-chevron-down"}></i>
                            </Col>
                        </Row>
                    </Card.Header>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        {
                            this.state.isloading
                                ?
                                <div style={{ height: "100px", padding: "50px" }}>
                                    <Loader className={"spinner"} position={"relative"} scale={0.5} radius={15} corners={1} color={"#000"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
                                </div>
                                :
                                <SubjectsView termCode={this.props.data.termCode} data={this.state.subjectData} />
                        }
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>;
    }
}